import axios from '../config/axios';

const API_BASE = '/contact-us';

export const contactService = {
  // Get all contacts
  getAllContacts: (page = 1, perPage = 20, filters = {}) => {
    const params = {
      page,
      per_page: perPage,
      ...filters
    };
    return axios.get(API_BASE, { params });
  },

  // Get single contact
  getContact: (contactId) => {
    return axios.get(`${API_BASE}/${contactId}`);
  },

  // Create contact (public)
  createContact: (data) => {
    return axios.post(API_BASE, data);
  },

  // Send reply to contact
  sendReply: (contactId, data) => {
    return axios.post(`${API_BASE}/${contactId}/reply`, data);
  },

  // Update reply
  updateReply: (contactId, data) => {
    return axios.put(`${API_BASE}/${contactId}/reply`, data);
  },

  // Delete contact
  deleteContact: (contactId) => {
    return axios.delete(`${API_BASE}/${contactId}`);
  },

  // Get statistics
  getStatistics: () => {
    return axios.get(`${API_BASE}/statistics`);
  },

  // Get unreplied contacts
  getUnreplied: () => {
    return axios.get(`${API_BASE}/unreplied`);
  },

  // Submit schedule shipment request
  scheduleShipment: (data) => {
    return axios.post(`${API_BASE}/schedule-shipment`, data);
  }
};
